import { render, staticRenderFns } from "./EditDiscreteCategoryDialog.vue?vue&type=template&id=4148234c"
import script from "./EditDiscreteCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditDiscreteCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports